import { defaultPm2PrintChunkClassName } from '@provider/print';
import { Scrambled } from './organisms/audio-component.scrambled.js';
import { Scrambled as Scrambled$1 } from './organisms/video-component.scrambled.js';
import { jsx } from 'react/jsx-runtime';

const printAudioComponentPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(Scrambled, {})
  }];
};
const print23VideoComponentPaper = () => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(Scrambled$1, {})
  }];
};
const mediaComponentPaperPrinters = {
  "audio-component": printAudioComponentPaper,
  "23-video-component": print23VideoComponentPaper
};

export { mediaComponentPaperPrinters };
//# sourceMappingURL=printer.to-paper.js.map
